var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loginForgot"},[(_vm.step.emailShow)?_c('enterEmail',{on:{"checkstep":_vm.checkstep}}):(_vm.step.successShow)?_c('success'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }